import EnrolmentsSerializer from './base';

export default class Identifier extends EnrolmentsSerializer {}
